import {NavLink, useNavigate} from "react-router-dom";
import {Logo, UserIcon, WorldIcon, YellowLogo} from "../icons";
import {BurgerMenu, Button} from "../common";
import {ROUTES} from "../../types";
import clsx from "clsx";
import React, {useState} from "react";

const NavBar = ({ isYellowLogo = false }: { isYellowLogo?: boolean }) => {
  const navigate = useNavigate();

  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);

  const handleOpenMenu = () => setIsOpenMenu(true);
  const handleCloseMenu = () => setIsOpenMenu(false);

  return (
    <nav className="max-w-[1320px] w-full mx-auto">
      <div className="w-full flex justify-between items-center lg:justify-start">
        <BurgerMenu open={isOpenMenu} onClose={handleCloseMenu} />
        <div className={
          clsx(
            "hidden relative lg:block z-10",
            isOpenMenu && "lg:z-[-1]"
          )
        }
             onClick={handleOpenMenu}
        >
          <span className="bg-mainBlack w-[22px] h-[2px] block mb-[6px]" />
          <span className="bg-mainBlack w-[22px] h-[2px] block mb-[6px]" />
          <span className="bg-mainBlack w-[22px] h-[2px] block" />
        </div>

        <div className="flex items-center gap-8 lg:hidden">
          <NavLink to={ROUTES.MAIN} className="text-black text-base leading-[18px]">Главная</NavLink>
          <NavLink to={ROUTES.PRODUCT} className="text-black text-base leading-[18px]">Продукты</NavLink>
          <NavLink to={ROUTES.ABOUT_US} className="text-black text-base leading-[18px]">О нас</NavLink>
        </div>

        <div className="lg:mx-auto"> {isYellowLogo ? <YellowLogo /> : <Logo />} </div>

        <div className="flex items-center">
          <NavLink to={ROUTES.SIGN_IN} className="cursor-pointer relative z-50" > <UserIcon /> </NavLink>
          {/*<span className="ml-3 cursor-pointer"> <WorldIcon /> </span>*/}
          <Button
            title={'Стать агентом'}
            onClick={() => navigate(ROUTES.SIGN_UP)}
            className="ml-5 max-w-[162px] lg:hidden relative z-50"
          />
        </div>
      </div>
    </nav>
  )
}

export default NavBar;
